import React, { Component } from 'react';
import {
  Table, Button, Icon, Header,
} from 'semantic-ui-react';
import handleViewport from 'react-in-viewport';
import FileChooser from 'components/lib/Choosers/FileChooser';
import { withTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import util from 'utils/utils';
import api from 'api';
import { EmptyBox } from 'components/lib/UI';

class IdeaAttachments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadingAttachment: false,
    };
  }

  addAttachment = (storedName, name) => {
    this.setState({ uploadingAttachment: true });
    let authToken = null;
    if (util.localStorageIsSupported()) {
      authToken = localStorage.getItem(`ideaAuthToken:${this.props.idea._id}`);
    }

    api.ideas.createAttachment(this.props.idea._id, { storedName, name, authToken }, ({ attachments }) => {
      this.setState({ uploadingAttachment: false }, () => this.props.updateIdea(attachments, ['attachments'], true));
      toast.success('File attached successfully');
    }, (err) => {
      toast.error(err.message);
      this.setState({ uploadingAttachment: false });
    });
  };

  deleteAttachment = (uuid) => {
    this.setState({ uploadingAttachment: true });
    let authToken = null;
    if (util.localStorageIsSupported()) {
      authToken = localStorage.getItem(`ideaAuthToken:${this.props.idea._id}`);
    }

    api.ideas.deleteAttachment(this.props.idea._id, uuid, ({ attachments }) => {
      this.setState({ uploadingAttachment: false }, () => this.props.updateIdea(attachments, ['attachments'], true));
      toast('File deleted successfully');
    }, (err) => {
      toast.error(err.message);
      this.setState({ uploadingAttachment: false });
    }, authToken);
  };

  render() {
    const {
      idea, user, t, isEditing,
    } = this.props;
    const { attachments = [] } = idea;
    const { uploadingAttachment } = this.state;
    const canEdit = util.canEditIdea(user, idea);
    return (
      <div>
        <Header as='h4'>{t('generic.attachments')}</Header>
        {attachments.length === 0
          && <EmptyBox>
            <h2>{t('ideas.attachments.none')}</h2>
            <p>{t('ideas.attachments.info')}</p>
            <FileChooser forType='idea' forId={idea._id}
              trigger={<Button icon='plus' size='small' content={t('ideas.actions.addAttachment')} />}
              onComplete={this.addAttachment}
            />
          </EmptyBox>
        }
        <Table basic='very'>
          {attachments.map((a) => (
            <Table.Row key={a.uuid}>
              <Table.Cell>
                <a href={a.url} target='_blank' rel="noopener noreferrer">
                  <Icon name='paperclip'/>{' '}{a.name}
                </a>
              </Table.Cell>
              {canEdit && isEditing
                && <Table.Cell textAlign='right'>
                  <Button icon='trash' loading={uploadingAttachment} onClick={() => this.deleteAttachment(a.uuid)} />
                </Table.Cell>
              }
            </Table.Row>
          ))}
        </Table>
        {canEdit && attachments.length > 0 && isEditing
          && <FileChooser forType='idea' forId={idea._id}
            trigger={<Button icon='plus' size='small' content={t('ideas.actions.addAttachment')} />}
            onComplete={this.addAttachment}
          />
        }
      </div>
    );
  }
}

export default withTranslation()(handleViewport(IdeaAttachments, { threshold: 1 }));
